import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorHandlerService } from '../errorHandler/error-handler.service';

/**
 * ApiInterceptor is currently used for handling HttpErrorResponses of 500-levels
 * and they will be sent to the DB for production debugging reason.
 * Any other Errors will be handled in the place where the API call was made.
 * Also, "error-report" API path is used to actually send error to DB so
 * it makes sense to ignor such 500 errors here to avoid infinite loop.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorHandlerService) {}

  /**
   * This interceptor will handle any server responses and run an actions when intercepted
   * (currently only error responses).
   * @param request is the outgoing API request
   * @param next is the default request handling (not intercepted, but sent to the server)
   * @returns void
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (
          err instanceof HttpErrorResponse &&
          err.status >= 500 &&
          !err.url?.includes('error-report')
        ) this.errorService.sendError(this.errorService.extractErrorDetails(err));

        /**throwError() will simply make the caller to receive the full response */
        return throwError(() => err);
      }),
    );
  }
}

/* standard Angular provider */
export const ApiInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ApiInterceptor,
  multi: true,
};
